import React from "react";
import styles from "../UploadImageQR.module.scss";
import classnames from "classnames";
import UploadMultipleImageBoxes from "./UploadMultipleImageBoxes.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/pro-regular-svg-icons";
import LineDivider from "../../divider/LineDivider.jsx";
import UploadMultipleImageIntroText from "./UploadMultipleImageIntroText.jsx";
import UploadMultipleImageFileInputButton from "./UploadMultipleImageFileInputButton.jsx";
import { QRCodeSVG } from "qrcode.react";

export default function UploadMultipleImageComputerPart({ appProps, multipleImageQrProps }) {
    const { readOnly, uploadButtonText, orText, scanInfoText, qrCodeValue } = multipleImageQrProps;

    return (
        <div>
            <div>
                <div
                    style={{
                        display: "flex",
                        gap: "0",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                    }}
                >
                    {!readOnly && (
                        <div
                            style={{
                                background: "#F4F6F8",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <UploadMultipleImageIntroText multipleImageQrProps={multipleImageQrProps} />

                            <div className={styles["upload-qr-wrapper"]}>
                                <div className={styles["upload-qr"]} data-test-id={"complaint-qr-url"} data-test-href={qrCodeValue}>
                                    <QRCodeSVG size={180} value={qrCodeValue} />
                                </div>
                                <div
                                    style={{
                                        marginTop: "16px",
                                        background: "white",
                                        padding: "10px",
                                        borderRadius: "100px",
                                        width: "40px",
                                        height: "40px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faCamera}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                        }}
                                    />
                                </div>
                                <div style={{ paddingBottom: "20px", fontWeight: 400 }} className={classnames(styles["scan-info-text"], styles["error"])}>
                                    {scanInfoText}
                                </div>
                            </div>
                        </div>
                    )}
                    {!readOnly && (
                        <div
                            style={{
                                marginTop: "30px",
                                marginBottom: "30px",
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                position: "relative",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <LineDivider style={{ width: "100%" }} />
                            <div
                                style={{
                                    position: "absolute",
                                    background: "white",
                                    padding: "10px",
                                    fontSize: "14px",
                                }}
                            >
                                {orText}
                            </div>
                        </div>
                    )}
                    <UploadMultipleImageFileInputButton appProps={appProps} multipleImageQrProps={multipleImageQrProps} htmlUploadId={"file-upload-pc-"} uploadButtonText={uploadButtonText} />
                </div>
            </div>
            <UploadMultipleImageBoxes appProps={appProps} multipleImageQrProps={multipleImageQrProps} />
        </div>
    );
}
